import { Box, Typography } from "@mui/material";
import { StyledExpos } from "./Expos.styled";
import { useExpo } from "../../stores/useExpo";
import { useEffect, useState } from "react";
import { Expo } from "../../Models/Expo";
import { ExpoItem } from "../../Components/ExpoItem/ExpoItem";
import { SERVERURL } from "../../Globals/Constants";
import {
  CalendarBlankIcon,
  InfoIcon,
  MapPinIcon,
  TrashSimpleIcon,
} from "@phosphor-icons/react";
import { useProfile } from "../../stores/useProfile";

export const Expos = () => {
  const { fetchAllExpos, removeExpo } = useExpo();
  const [expos, setExpos] = useState<Expo[]>([]);
  const {user} = useProfile();

  const updateitems = async () => {
    const res = await fetchAllExpos();
    if (res) setExpos(res.reverse());
  };

  useEffect(() => {
    updateitems();
    // eslint-disable-next-line 
  }, []);

  const handleRemove = async (id: number) => {
    if (!user) return;
    const res = await removeExpo(user, id);

    if (res === 200) updateitems();
  };

  return (
    <StyledExpos>
      <Box className="header">
        <Typography variant="h1">Expo's</Typography>
      </Box>
      <Box className="expoWrapper">
        {expos.map((expo) => (
          <>
            {expo.files.length > 1 ? (
              <ExpoItem expo={expo} onRemove={updateitems} />
            ) : (
              <Box className="newExpo">
                <Box className="newExpoHeader"><Typography variant="h2">Volgende Expo</Typography>
                {user && <TrashSimpleIcon size={32} weight="bold" onClick={() => handleRemove(expo.id)}/>}</Box>
                <Box className="wrapper">
                  <Box className="imageWrapper">
                    <img src={`${SERVERURL}${expo.files[0].filePath}`} alt={expo.title}/>
                  </Box>
                  <Box className="info">
                    <Typography variant="h2">{expo.title}</Typography>
                    <Box className="infoItem">
                      <CalendarBlankIcon size={32} weight="bold" />
                      <Typography variant="h4">{expo.time}</Typography>
                    </Box>
                    <Box className="infoItem">
                      <MapPinIcon size={32} weight="bold" />
                      <Typography variant="h4">{expo.location}</Typography>
                    </Box>
                    <Box className="infoItem">
                      <InfoIcon size={32} weight="bold" />
                      <Typography variant="h4">{expo.info}</Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
          </>
        ))}
      </Box>
    </StyledExpos>
  );
};
